var map = {
	"./decidim/collaborative_texts/decidim_collaborative_texts.svg": "../decidim-collaborative_texts/app/packs/images/decidim/collaborative_texts/decidim_collaborative_texts.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "../decidim-collaborative_texts/app/packs/images sync recursive ^\\.\\/.*$";